/* SD mobile product helpers:
   - pickup pill opens the store-info drawer
   - wishlist heart pops a "Saved to wishlist" toast (reuses the global
     #sd-added-toast look from sd-added-toast.liquid)
   All handlers are delegated so they survive the theme's DOM re-renders. */
(function () {
  /* pickup pill = tap target for the store-info drawer (mobile only) */
  document.addEventListener('click', function (e) {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var line = e.target.closest && e.target.closest('.sd-pickup-line');
    if (!line) return;
    var btn = document.getElementById('ShowPickupAvailabilityDrawer');
    if (btn) btn.click();
  });

  /* toast, styled by the global sd-added-toast snippet's CSS */
  var hideTimer = null;
  function toast(msg) {
    var el = document.getElementById('sd-added-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sd-added-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<span class="sd-tick" aria-hidden="true">&#10003;</span><span class="sd-msg"></span>';
      document.body.appendChild(el);
    }
    el.querySelector('.sd-msg').textContent = msg;
    el.classList.add('sd-show');
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { el.classList.remove('sd-show'); }, 2600);
  }

  /* wishlist: the button flips its wrap to .is-saved optimistically on a
     successful save (including via the multi-list picker). Watch for that
     transition shortly after any tap inside the widget. */
  document.addEventListener('click', function (e) {
    var wrap = e.target.closest && e.target.closest('[data-sd-wl]');
    if (!wrap) return;
    if (wrap.classList.contains('is-saved')) return; /* already saved */
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (wrap.classList.contains('is-saved')) {
        clearInterval(poll);
        toast('Saved to wishlist');
      } else if (tries > 20) {
        clearInterval(poll);
      }
    }, 100);
  });
})();
